import React, { useState, useEffect } from "react";
import api from "../../api/api";

const card = { background: "var(--bg-surface)", border: "1px solid var(--border)", borderRadius: "var(--radius-xl)", padding: 24, marginBottom: 16 };
const badge = (s) => ({
  display: "inline-block", padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
  background: s === "approved" ? "var(--success-soft)" : s === "rejected" ? "var(--danger-soft)" : "var(--warning-soft)",
  color: s === "approved" ? "var(--success)" : s === "rejected" ? "var(--danger)" : "var(--warning)",
});
const btn = (v = "primary") => ({
  padding: "8px 16px", borderRadius: "var(--radius-lg)", border: "none", cursor: "pointer",
  fontWeight: 600, fontSize: 12,
  background: v === "approve" ? "var(--success)" : v === "reject" ? "var(--danger)" : "var(--bg-elevated)",
  color: v === "secondary" ? "var(--text-main)" : "#fff",
});

export default function AnalystApplications() {
  const [apps, setApps]           = useState([]);
  const [loading, setLoading]     = useState(true);
  const [rejectModal, setRejectModal] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [filter, setFilter]       = useState("pending");

  const load = () => {
    setLoading(true);
    api.get("/api/admin/analyst-applications").then(r => {
      setApps(r.data?.applications || []);
      setLoading(false);
    });
  };

  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    if (!window.confirm("Approve aplikasi ini? Signal set akan dibuat dan auto-sync diaktifkan.")) return;
    await api.post(`/api/admin/analyst-applications/${id}/approve`);
    load();
  };

  const reject = async () => {
    await api.post(`/api/admin/analyst-applications/${rejectModal}/reject`, { reason: rejectReason });
    setRejectModal(null);
    setRejectReason("");
    load();
  };

  const filtered = apps.filter(a => filter === "all" || a.status === filter);

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text-main)" }}>Analyst Applications</div>
        <div style={{ fontSize: 13, color: "var(--text-faint)", marginTop: 4 }}>
          Review dan approve trader yang ingin jadi analyst
        </div>
      </div>

      {/* Filter tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        {["pending", "approved", "rejected", "all"].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            style={{ padding: "6px 16px", borderRadius: 20, border: "none", cursor: "pointer", fontSize: 12, fontWeight: 600,
              background: filter === f ? "var(--accent)" : "var(--bg-elevated)",
              color: filter === f ? "#fff" : "var(--text-muted)" }}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
            {f !== "all" && <span style={{ marginLeft: 6, opacity: 0.8 }}>({apps.filter(a => a.status === f).length})</span>}
          </button>
        ))}
      </div>

      {loading && <div style={{ color: "var(--text-faint)", fontSize: 14 }}>Loading...</div>}

      {!loading && filtered.length === 0 && (
        <div style={{ ...card, textAlign: "center", color: "var(--text-faint)", padding: 40 }}>
          Tidak ada aplikasi {filter !== "all" ? filter : ""}
        </div>
      )}

      {filtered.map(a => (
        <div key={a.id} style={card}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                <span style={{ fontSize: 15, fontWeight: 700, color: "var(--text-main)" }}>{a.analyst_name}</span>
                <span style={badge(a.status)}>{a.status.toUpperCase()}</span>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 10 }}>
                {[
                  { label: "Email", value: a.email },
                  { label: "Nama", value: a.name || "-" },
                  { label: "Account", value: a.account_number },
                  { label: "Broker", value: a.broker },
                  { label: "Apply", value: new Date(a.created_at).toLocaleDateString("id-ID", { day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit" }) },
                  { label: "Strategy", value: a.strategy || "-" },
                ].map(({ label, value }) => (
                  <div key={label}>
                    <span style={{ fontSize: 10, color: "var(--text-faint)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}: </span>
                    <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{value}</span>
                  </div>
                ))}
              </div>

              {a.bio && (
                <div style={{ fontSize: 12, color: "var(--text-faint)", background: "var(--bg-elevated)", padding: "8px 12px", borderRadius: "var(--radius-lg)", marginBottom: 10 }}>
                  {a.bio}
                </div>
              )}
            </div>

            {a.status === "pending" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button style={btn("approve")} onClick={() => approve(a.id)}> Approve</button>
                <button style={btn("reject")} onClick={() => { setRejectModal(a.id); setRejectReason(""); }}> Reject</button>
              </div>
            )}
          </div>
        </div>
      ))}

      {/* Reject Modal */}
      {rejectModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "var(--bg-surface)", borderRadius: "var(--radius-xl)", padding: 28, width: 400, border: "1px solid var(--border)" }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text-main)", marginBottom: 14 }}>Alasan Penolakan</div>
            <textarea rows={4} value={rejectReason} onChange={e => setRejectReason(e.target.value)}
              placeholder="Tulis alasan penolakan (opsional)..."
              style={{ width: "100%", padding: "10px 12px", borderRadius: "var(--radius-lg)", border: "1px solid var(--border)", background: "var(--bg-elevated)", color: "var(--text-main)", fontSize: 13, resize: "vertical", boxSizing: "border-box", marginBottom: 16 }} />
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button style={btn("secondary")} onClick={() => setRejectModal(null)}>Batal</button>
              <button style={btn("reject")} onClick={reject}>Reject Aplikasi</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
